<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";
import { mapState } from "../../context/context";
import Text from "./Text.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Text },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    init?: string;
    placeholder?: string;
    rows?: number;
    cols?: number;
    maxlength?: number;
    minlength?: nunber;
    fontSize?: string;
  }>(),
  {
    placeholder: "",
    rows: 3,
    maxlength: 200,
    fontSize: "14px"
  }
);

const emits = defineEmits<{
  (event: "input", text: string): void;
  (event: "yz-input", text: string): void;
}>();

const mappedState = mapState(["color.panelPattern", "color.fontPattern"]);

const text = ref(props.init || "");

function focus() {}

function blur() {}

function input(e: Event) {
  // 每次内容发生变化都会触发
  text.value = (e.target as HTMLTextareaElement).value;
  if (text.value) {
    emits("input", text.value);
    emits("yz-input", text.value);
  }
}

function change(e: Event) {
  // 只有在内容改变并且失去焦点时才触发
}

onMounted(() => {});

onUnmounted(() => {});

defineExpose({});
</script>

<template>
  <div
    class="textarea"
    :style="{
      backgroundColor: mappedState['color.panelPattern'].value,
      borderRadius: '4px'
    }"
  >
    <textarea
      class="textarea-raw"
      name="textarea-raw"
      :autocapitalize="false"
      autocomplete="off"
      autofocus="off"
      :disabled="false"
      :readonly="false"
      :required="false"
      :rows="props.rows"
      :cols="props.cols"
      :maxlength="props.maxlength"
      :minlength="props.minlength"
      :placeholder="props.placeholder"
      :style="{
        fontSize: props.fontSize,
        color: mappedState['color.fontPattern'].value,
        border: '0px solid transparent'
      }"
      @focus="focus"
      @blur="blur"
      @input="input"
      @change="change"
      >{{ text }}</textarea
    >
  </div>
</template>

<style scoped>
.textarea {
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.textarea textarea.textarea-raw {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  line-height: 1.4;
  display: block;
  box-sizing: border-box;
  position: relative;
  background: transparent;
  outline: none;
  box-shadow: none;
  resize: none; /* 控制 textarea 是否可调整大小 */
}
.textarea textarea.textarea-raw:invalid {
}
.textarea textarea.textarea-raw:valid {
}

.textarea textarea:-moz-placeholder,
.textarea textarea:-ms-input-placeholder,
.textarea textarea::-webkit-input-placeholder,
.textarea textarea::placeholder {
  color: var(--yz-gap-common, #cccccc);
}
</style>
